import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getAllPaymentMethods({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/payment_method",
        method: "GET",
      });
      commit("SET_PAYMENT_METHODS", response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async savePaymentMethod({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/payment_method",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_PAYMENT_METHOD, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updatePaymentMethod({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/payment_method/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_PAYMENT_METHOD, response.data.data);
    } catch (error) {
      throw error.response.data;
    }
  },
  async deletePaymentMethod({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/payment_method/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_PAYMENT_METHOD, { id });
    } catch (error) {
      throw error.response.data;
    }
  },
  resetPaymentMethod({ commit }) {
    commit(MutationsType.SET_PAYMENT_METHOD, null);
  },
};
